const CMS_API_URL = 'https://cms.muddymat.com/restapi/analytics';
const CMS_SITE_NAME = 'Online Store';

const CMS_SESSION_KEY_STORAGE = 'cmsAnalyticsSessionKey';
const CMS_SESSION_ID_STORAGE = 'cmsAnalyticsSessionId';
const CMS_LAST_ACTIVITY_STORAGE = 'cmsAnalyticsLastActivityAt';
const CMS_SESSION_IDLE_MS = 30 * 60 * 1000;

function getUtcDay(time) {
  return new Date(time).toISOString().slice(0, 10);
}

function isCmsSessionExpired(now) {
  const lastActivity = Number(localStorage.getItem(CMS_LAST_ACTIVITY_STORAGE));

  return (
    !lastActivity ||
    now - lastActivity > CMS_SESSION_IDLE_MS ||
    getUtcDay(lastActivity) !== getUtcDay(now)
  );
}

function touchCmsSession() {
  const now = Date.now();

  if (isCmsSessionExpired(now)) {
    localStorage.setItem(CMS_SESSION_KEY_STORAGE, crypto.randomUUID());
    localStorage.removeItem(CMS_SESSION_ID_STORAGE);
  }

  localStorage.setItem(CMS_LAST_ACTIVITY_STORAGE, String(now));
}

function getCmsSessionKey() {
  let sessionKey = localStorage.getItem(CMS_SESSION_KEY_STORAGE);

  if (!sessionKey) {
    sessionKey = crypto.randomUUID();
    localStorage.setItem(CMS_SESSION_KEY_STORAGE, sessionKey);
  }

  return sessionKey;
}

async function ensureCmsSession() {
  touchCmsSession();

  const existingSessionId = localStorage.getItem(
    CMS_SESSION_ID_STORAGE,
  );

  if (
    existingSessionId &&
    existingSessionId !== 'undefined'
  ) {
    saveCmsSessionToCart(existingSessionId).catch((error) => {
      console.error('Failed to sync CMS session with cart:', error);
    });

    return existingSessionId;
  }

  localStorage.removeItem(CMS_SESSION_ID_STORAGE);

  const response = await fetch(`${CMS_API_URL}/session`, {
    method: 'POST',
    keepalive: true,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      siteName: CMS_SITE_NAME,
      sessionKey: getCmsSessionKey(),
      referrer: document.referrer || undefined,
      userAgent: navigator.userAgent,
    }),
  });

  const result = await response.json();
  const sessionId = result?.data?.sessionId;

  if (!response.ok || !sessionId) {
    throw new Error('CMS session was not created');
  }

  localStorage.setItem(
    CMS_SESSION_ID_STORAGE,
    sessionId,
  );

  saveCmsSessionToCart(sessionId).catch((error) => {
    console.error('Failed to sync CMS session with cart:', error);
  });

  return sessionId;
}

async function saveCmsSessionToCart(sessionId) {
  const response = await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      attributes: {
        _cms_session_id: sessionId,
      },
    }),
  });

  if (!response.ok) {
    throw new Error(
      `Failed to save CMS session to cart: ${response.status}`,
    );
  }
}

async function sendCmsEvent(eventName) {
  if (navigator.webdriver === true) return;

  try {
    const sessionId = await ensureCmsSession();

    const response = await fetch(`${CMS_API_URL}/event`, {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: crypto.randomUUID(),
        sessionId,
        siteName: CMS_SITE_NAME,
        eventName,
        occurredAt: new Date().toISOString(),
        pageUrl: window.location.href,
        pagePath: window.location.pathname,
      }),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(`CMS event request failed with status ${response.status}`);
    }

    console.log(`CMS ${eventName} response:`, result);
  } catch (error) {
    console.error(`CMS ${eventName} failed:`, error);
  }
}

sendCmsEvent('PAGE_VIEW');

document.addEventListener('submit', (event) => {
  const form = event.target;

  if (!(form instanceof HTMLFormElement)) return;
  if (!form.action.includes('/cart/add')) return;

  sendCmsEvent('ADD_TO_CART');
});

document.addEventListener('click', (event) => {
  const target = event.target;

  if (!(target instanceof Element)) return;

  const checkoutButton = target.closest(
    'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button'
  );

  if (!checkoutButton) return;

  sendCmsEvent('CHECKOUT_CLICK');
});